// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__QqCdZ","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2tdY7"};